var _rect, _rect2, _rect3, _text, _text2, _text3, _circle, _circle2, _circle3, _path, _rect4, _text4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeoplelinkHr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 750",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 750,
    fill: "#202b4d"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 70,
    width: 1060,
    height: 610,
    rx: 26,
    fill: "#f8f9ff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 70,
    width: 1060,
    height: 82,
    rx: 26,
    fill: "#5968c8"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 122,
    fontFamily: "Arial",
    fontSize: 28,
    fontWeight: 700,
    fill: "#fff"
  }, "PEOPLELINK HR")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 250,
    fontFamily: "Arial",
    fontSize: 62,
    fontWeight: 700,
    fill: "#202b4d"
  }, "People make progress.")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 300,
    fontFamily: "Arial",
    fontSize: 23,
    fill: "#6c7593"
  }, "Better connections for better teams.")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 900,
    cy: 350,
    r: 62,
    fill: "#f4b756"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 790,
    cy: 425,
    r: 62,
    fill: "#75c6c4"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1010,
    cy: 425,
    r: 62,
    fill: "#ee7e77"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M790 530c0-70 220-70 220 0",
    fill: "#5968c8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 420,
    width: 230,
    height: 64,
    rx: 32,
    fill: "#202b4d"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 180,
    y: 460,
    fontFamily: "Arial",
    fontSize: 20,
    fontWeight: 700,
    fill: "#fff"
  }, "Meet your match")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 545,
    width: 220,
    height: 55,
    rx: 12,
    fill: "#e4e7fb"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 370,
    y: 545,
    width: 220,
    height: 55,
    rx: 12,
    fill: "#e4e7fb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeoplelinkHr);
export default __webpack_public_path__ + "static/media/peoplelink-hr.a372d710eb63ba9cee1bdfc48a1be201.svg";
export { ForwardRef as ReactComponent };